import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { ColorOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export interface IPageComponentZippyContentData {
    title?: string;
    tabs: IPageComponentZippyContentDataTabs[];
}

export interface IPageComponentZippyContentDataTabs {
    name: string;
    title: string;
    title_style: string;
    arrow_style: string;
    border_color?: string;
    components?: NICmsContentComponent.IData[];
}
let uid = 0;
@Component({
    selector: 'page-component-zippy',
    templateUrl: './zippy-content.html',
    standalone: true,
    imports: [ICmsClientModule, NgClass, ZippyModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentZippyContentComponent>({
    id: 'zippy',
    name: 'Zippy',
    tags: ['text', 'textarea'],
    isAdvanced: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            default: 'Title'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'tabs',
            title: 'Tab',
            itemName: 'tab',
            itemNameField: 'title',
            defaultSize: 1,
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Title of your zippy'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'title_style',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Title Style',
                    options: TextStyleOptions,
                    default: 'h2'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'arrow_style',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Arrow Style',
                    options: TextStyleOptions,
                    default: ''
                },
                <NICmsContentField.IChoiceField>{
                    key: 'border_color',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Border color',
                    options: ColorOptions,
                    previewMode: 'color'
                },
                <NICmsContentField.IComponentsField>{
                    key: 'components',
                    type: NICmsContentField.EFieldType.components,
                    title: 'Content components',
                    itemName: 'component',
                    default: []
                }
            ]
        }
    ]
})
export class PageComponentZippyContentComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentZippyContentData;
    protected uid = uid++;
}
